import { FirestoreError } from "firebase/firestore";

/**
 * Returns true if the given error is a Firestore "permission-denied" error,
 * e.g. when a user tries to access a project they are not assigned to.
 */
export function isPermissionDeniedError(error: unknown): boolean {
  return (
    error instanceof Error &&
    (error as FirestoreError).code === "permission-denied"
  );
}
